<template>
  <div class="product-section">
    <div class="df vertical df-around">
      <div class="title">{{ query.localDate }} 工艺变更</div>
      <a-space>
        <!-- <select-day
          :defaultVal="query.localDate"
          @userDelectDay="userSelectDay"
        ></select-day> -->
        <a-button @click="handleUpdateAbnormalProblem(null)">新增</a-button>
      </a-space>
    </div>
    <form-vue
      ref="fqcRef"
      @updateTable="updateTable"
      :type="props.type"
      :produceOrTpc="props.produceOrTpc"
    ></form-vue>
    <div ref="tableScrollRef">
      <div class="df both-side" style="margin-top: 20px">
        <div style="margin: 0 auto; width: calc(100vw - 160px)">
          <a-table
            :columns="productColumns"
            :loading="tableLoading"
            :data-source="tableData"
            :pagination="false"
            :rowClassName="
              (record, index) => (index % 1 === 0 ? 'table-striped' : null)
            "
            rowKey="id"
            bordered
            :scroll="{ x: 'calc(100vw - 160px)' }"
          >
            <template #action="{ record }">
              <a-space>
                <a-button @click="handleEdit(record)" size="small"
                  >编辑</a-button
                >
                <a-button
                  v-if="props.deleteAuthority"
                  @click="handleDelete(record)"
                  size="small"
                  type="danger"
                  >删除</a-button
                >
              </a-space>
            </template>

            <template #isGroupLeaderFirstConfirm="{ record }">
              {{ record.isGroupLeaderFirstConfirm ? "是" : "否" }}
            </template>

            <template #isGroupMembersQualitySpotCheck="{ record }">
              {{ record.isGroupMembersQualitySpotCheck ? "是" : "否" }}
            </template>

            <template #isGroupMembersFirstConfirm="{ record }">
              {{ record.isGroupMembersFirstConfirm ? "是" : "否" }}
            </template>

            <template #isGroupMembersSecondaryTrain="{ record }">
              {{ record.isGroupMembersSecondaryTrain ? "是" : "否" }}
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref, watch, inject } from "vue";
import {
  getProcessChangeList,
  deleteProcessChange,
} from "@/request/view/product";
import searchVue from "@/views/productDaily/components/quality/PQC/threePieced/search.vue";
import formVue from "@/views/productDaily/components/product/components/processUpdate/form.vue";
import SelectDay from "@/views/repairprogress/compoments/selectDay.vue";
import { useStore } from "vuex";
import { showModal } from "@/views/repairprogress/serve/modal";
import { Toast, debounce, timeStampToTime } from "@/utils";

export default defineComponent({
  props: {
    deleteAuthority: Boolean,
    type: String,
    produceOrTpc: String,
  },
  components: {
    searchVue,
    formVue,
    SelectDay,
  },
  setup(props, context) {
    const query = reactive({
      localDate: timeStampToTime("", "upload"),
      type: props.type,
      produceOrTpc: props.produceOrTpc
    });
    const store = useStore();

    const userId = computed(() => store.state.user.user.id);

    const productColumns = [
      {
        title: "序号",
        dataIndex: "id",
        width: 80,
        align: "center",
      },
      {
        title: "变更内容",
        dataIndex: "changeContent",
        width: 165,
        align: "center",
      },
      {
        title: "组长首样确认",
        slots: {
          customRender: "isGroupLeaderFirstConfirm",
        },
        width: 165,
        align: "center",
      },
      {
        title: "组员二次培训",
        dataIndex: "isGroupMembersSecondaryTrain",
        slots: {
          customRender: "isGroupMembersSecondaryTrain",
        },
        width: 165,
        align: "center",
      },
      {
        title: "组员首样确认",
        slots: {
          customRender: "isGroupMembersFirstConfirm",
        },
        width: 165,
        align: "center",
      },
      {
        title: "组员质量抽查",
        slots: {
          customRender: "isGroupMembersQualitySpotCheck",
        },
        width: 165,
        align: "center",
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        width: 100,
        align: "center",
        fixed: "right",
      },
    ];

    const tableLoading = ref(false);

    const searchRef = ref();

    const fqcRef = ref();

    const tableScrollRef = ref();

    const tableData = reactive([]);

    const getTableData = () => {
      tableLoading.value = true;
      getProcessChangeList(query)
        .then((res) => {
          tableLoading.value = false;
          tableData.length = 0;
          if (
            res.code === 200 &&
            res.message === "成功" &&
            res.data &&
            res.data[props.type]
          ) {
            tableData.push(...res.data[props.type]);
            // tableData.forEach((item) => {
            //   item.isGroupLeaderFirstConfirm = item.isGroupLeaderFirstConfirm
            //     ? "是"
            //     : "否";
            //   item.isGroupMembersQualitySpotCheck =
            //     item.isGroupMembersQualitySpotCheck ? "是" : "否";
            //   item.isGroupMembersFirstConfirm = item.isGroupMembersFirstConfirm
            //     ? "是"
            //     : "否";
            //   item.isGroupMembersSecondaryTrain =
            //     item.isGroupMembersSecondaryTrain ? "是" : "否";
            // });
          }
        })
        .catch((err) => {
          tableLoading.value = false;
          console.log(err, "报错");
        });
    };

    const handleDelete = (record) => {
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteProcessChange([record.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200) {
                getTableData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const handleEdit = (data) => {
      fqcRef.value.openModal("editProcessUpdate", data);
    };

    const handleUpdateAbnormalProblem = () => {
      fqcRef.value.openModal("addProcessUpdate");
    };

    const userSelectDay = (time) => {
      if (time) {
        query.localDate = time;
        getTableData();
      }
    };

    const updateTable = () => {
      getTableData();
    };

    const tabActivekey = inject("tabActivekey", null);
    watch(
      () => tabActivekey,
      (val) => {
        if (val.value === props.type) {
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    const cascadeDate = inject("cascadeDate", null);
    watch(
      () => cascadeDate,
      (val) => {
        if (!val.value) return;
        const date = val.value.format("YYYY-MM-DD");
        if (date !== query.localDate) {
          query.localDate = date;
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      userId,
      query,
      handleDelete,
      userSelectDay,
      productColumns,
      searchRef,
      fqcRef,
      tableData,
      tableLoading,
      tableScrollRef,
      handleUpdateAbnormalProblem,
      updateTable,
      handleEdit,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
